// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Lens_Setter from "../Data.Lens.Setter/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Profunctor_Strong from "../Data.Profunctor.Strong/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Measurement from "../Fusion.Data.Measurement/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Visonum_Cross_Assets_Imgs from "../Visonum.Cross.Assets.Imgs/index.js";
import * as Visonum_Cross_Components_App_Types_AppState from "../Visonum.Cross.Components.App.Types.AppState/index.js";
import * as Visonum_Cross_Extra_Lenses from "../Visonum.Cross.Extra.Lenses/index.js";
import * as Visonum_Cross_Theme from "../Visonum.Cross.Theme/index.js";
import * as Visonum_Cross_Types_Brand from "../Visonum.Cross.Types.Brand/index.js";
import * as Visonum_Cross_Util from "../Visonum.Cross.Util/index.js";
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(Fusion_Data_Duration.durationDuration)(Data_Time_Duration.durationSeconds);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var convertDuration1 = /* #__PURE__ */ Data_Time_Duration.convertDuration(Data_Time_Duration.durationSeconds)(Fusion_Data_Duration.durationDuration);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Maybe.functorMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var maximum = /* #__PURE__ */ Data_Foldable.maximum(Data_Ord.ordNumber)(Data_Foldable.foldableArray);
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var fromDuration = /* #__PURE__ */ Data_Time_Duration.fromDuration(Fusion_Data_Duration.durationDuration);
var max = /* #__PURE__ */ Data_Ord.max(Fusion_Data_Duration.ordDuration);
var prop = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "yAxis";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop1 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "lines";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop2 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "ticks";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop3 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "max";
    }
})()()(Data_Profunctor_Strong.strongFn);
var maximum1 = /* #__PURE__ */ Data_Foldable.maximum(Fusion_Data_Speed.ordSpeed)(Data_Foldable.foldableArray);
var prop4 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "print";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop5 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "xAxis";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop6 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "pixelsPerX";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop7 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "min";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop8 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "data_";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop9 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "extra";
    }
})()()(Data_Profunctor_Strong.strongFn);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var prop10 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "main";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop11 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "markers";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop12 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "show";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop13 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "styles";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop14 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "lineColor";
    }
})()()(Data_Profunctor_Strong.strongFn);
var convertDuration2 = /* #__PURE__ */ Data_Time_Duration.convertDuration(Data_Time_Duration.durationMilliseconds)(Fusion_Data_Duration.durationDuration);
var maximum2 = /* #__PURE__ */ Data_Foldable.maximum(Fusion_Data_Duration.ordDuration)(Data_Foldable.foldableArray);
var prop15 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "yAxisLabelText";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop16 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "haveShadow";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop17 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "inheritFonts";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop18 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "horizontalLine";
    }
})()()(Data_Profunctor_Strong.strongFn);
var pixelsPerX = 7.0e-2;
var getTicksX = function (v) {
    var startTime$prime = convertDuration(v.startTime);
    var firstTick = Data_Int.ceil(coerce(startTime$prime));
    var endTime$prime = convertDuration(v.endTime);
    var lastTick = Data_Int.floor(coerce(endTime$prime));
    var ticks = Data_Array.range(firstTick)(lastTick);
    return map(function ($227) {
        return convertDuration1(Data_Time_Duration.Seconds(Data_Int.toNumber($227)));
    })(ticks);
};
var getRoundTicks = function (v) {
    var unRoundedTickSize = v.max / 10.0;
    var roundedTickSize = Data_Maybe.fromMaybe(1.0)(Data_Array.find(function (v1) {
        return v1 > unRoundedTickSize;
    })(append([ 1.0, 5.0 ])(append([ 10.0, 50.0 ])(append([ 100.0, 500.0 ])(append([ 1000.0, 5000.0 ])(append([ 10000.0, 50000.0 ])(append([ 100000.0, 500000.0 ])(append([ 1000000.0, 5000000.0 ])(append([ 1.0e7, 5.0e7 ])(append([ 1.0e8, 5.0e8 ])(append([ 1.0e9, 5.0e9 ])(append([ 1.0e10, 5.0e10 ])(append([ 1.0e11, 5.0e11 ])([ 1.0e12, 5.0e12 ]))))))))))))));
    var count = Data_Int.ceil(v.max / roundedTickSize);
    return map(function (index) {
        return Data_Int.toNumber(index) * roundedTickSize;
    })(Data_Array.range(0)(count));
};
var formatSpeed = function (speed) {
    return Data_Number_Format.toStringWith(Data_Number_Format.fixed(0))(Fusion_Data_Speed.toBps(speed) * 1.0e-6);
};
var durTo = function (dictDuration) {
    var convertDuration3 = Data_Time_Duration.convertDuration(dictDuration);
    return function (dictDuration1) {
        return convertDuration3(dictDuration1);
    };
};
var durTo1 = /* #__PURE__ */ durTo(Fusion_Data_Duration.durationDuration);
var durTo2 = /* #__PURE__ */ durTo1(Data_Time_Duration.durationSeconds);
var durTo3 = /* #__PURE__ */ durTo1(Data_Time_Duration.durationMilliseconds);
var defaultChartStyles = /* #__PURE__ */ (function () {
    return {
        lineColor: Visonum_Cross_Types_Brand.defaultColor,
        dotFillColor: Visonum_Cross_Types_Brand.defaultColor,
        inheritFonts: false,
        haveShadow: true,
        yAxisLabelText: Data_Maybe.Nothing.value
    };
})();
var defaultChartProps = function (embedOpts) {
    var yTicks = [ 0.0, 10.0, 20.0, 30.0, 40.0, 50.0, 60.0, 70.0, 80.0, 90.0 ];
    var xTicks = [ 0.0, 10.0, 20.0, 30.0, 40.0, 50.0, 60.0, 70.0, 80.0, 90.0 ];
    return {
        data_: {
            main: [ new Data_Tuple.Tuple(0.0, 0.0), new Data_Tuple.Tuple(10.0, 10.0), new Data_Tuple.Tuple(20.0, 10.0), new Data_Tuple.Tuple(30.0, 30.0), new Data_Tuple.Tuple(40.0, 30.0), new Data_Tuple.Tuple(50.0, 50.0), new Data_Tuple.Tuple(60.0, 50.0), new Data_Tuple.Tuple(70.0, 70.0), new Data_Tuple.Tuple(80.0, 70.0), new Data_Tuple.Tuple(90.0, 90.0), new Data_Tuple.Tuple(100.0, 100.0) ],
            extra: [ [ new Data_Tuple.Tuple(0.0, 0.0), new Data_Tuple.Tuple(10.0, 20.0), new Data_Tuple.Tuple(20.0, 0.0), new Data_Tuple.Tuple(30.0, 40.0), new Data_Tuple.Tuple(40.0, 20.0), new Data_Tuple.Tuple(50.0, 60.0), new Data_Tuple.Tuple(60.0, 40.0), new Data_Tuple.Tuple(70.0, 80.0), new Data_Tuple.Tuple(80.0, 60.0), new Data_Tuple.Tuple(90.0, 90.0), new Data_Tuple.Tuple(100.0, 100.0) ] ]
        },
        markers: [ {
            position: new Data_Tuple.Tuple(30.0, 40.0),
            icon: Visonum_Cross_Assets_Imgs.imgs.warning
        } ],
        xAxis: {
            min: 0.0,
            pixelsPerX: 10.0,
            ticks: xTicks,
            lines: xTicks,
            print: new Data_Maybe.Just(function (v) {
                return show(v);
            }),
            show: true
        },
        yAxis: {
            max: 100.0,
            ticks: yTicks,
            lines: yTicks,
            print: new Data_Maybe.Just(function (v) {
                return show(v);
            }),
            show: true
        },
        horizontalLine: Data_Maybe.Nothing.value,
        smoothingFactor: 0.1,
        styles: defaultChartStyles
    };
};
var addLoadConfig = function (v) {
    return function (cfg) {
        var yToSpeed = function (v1) {
            return Fusion_Data_Speed.fromBps(v1);
        };
        var xToDuration = function (v1) {
            return Fusion_Data_Duration.fromMs(v1);
        };
        var totalPoints = Visonum_Cross_Components_App_Types_AppState.getTotalPoints(v.loadResult);
        var startTime = Data_Maybe.fromMaybe(Fusion_Data_Timestamp.timeIntervalSince1970(mempty))(mapFlipped(Data_Array.head(totalPoints))(function (v1) {
            return v1.timestamp;
        }));
        var speedToY = function (speed) {
            return Fusion_Data_Speed.toBps(speed);
        };
        var speedArrayFromHorizLine = function (maxBookedSpeed) {
            return Data_Maybe.maybe([  ])(pure)(map1(yToSpeed)(maxBookedSpeed));
        };
        var printY = function (speed) {
            return formatSpeed(speed);
        };
        var printX = function (d) {
            return Data_Number_Format.toStringWith(Data_Number_Format.fixed(0))(unwrap(durTo2(d)));
        };
        var maxSpeed = Visonum_Cross_Util.getVisibleSpeedMax(map(function (v1) {
            return v1.speed;
        })(v.loadResult.intermediates.totalSpeed));
        var getMaxHeight = function (horizontalLine) {
            return function (mSpeed) {
                if (horizontalLine instanceof Data_Maybe.Nothing) {
                    return Fusion_Data_Speed.toBps(mSpeed);
                };
                if (horizontalLine instanceof Data_Maybe.Just) {
                    var maxValue = maximum([ horizontalLine.value0 + 1.1e7, Fusion_Data_Speed.toBps(mSpeed) ]);
                    return Data_Maybe.fromMaybe(0.0)(maxValue);
                };
                throw new Error("Failed pattern match at Visonum.Cross.Views.Chart.Configs (line 230, column 42 - line 236, column 33): " + [ horizontalLine.constructor.name ]);
            };
        };
        var ticksY = mapFlipped1(getRoundTicks({
            max: getMaxHeight(cfg.horizontalLine)(maxSpeed)
        }))(Fusion_Data_Speed.fromBps);
        var durationToX = function (dur) {
            return (function (v1) {
                return v1;
            })(fromDuration(dur));
        };
        var dataPointsToDuration = function (start) {
            return map(function (v1) {
                return {
                    duration: Fusion_Data_Timestamp.diff(v1.timestamp)(start),
                    speed: v1.speed
                };
            });
        };
        var perStreamPoints = map(dataPointsToDuration(startTime))(Visonum_Cross_Components_App_Types_AppState.getPerStreamPoints(v.loadResult));
        var points = dataPointsToDuration(startTime)(totalPoints);
        var maxDur = Data_Maybe.fromMaybe(mempty)(map1(function (v1) {
            return v1.duration;
        })(Data_Array.last(points)));
        var linesX = getTicksX({
            startTime: mempty,
            endTime: max(Fusion_Data_Duration.fromMs(100000.0))(maxDur)
        });
        var ticksX = getTicksX({
            startTime: mempty,
            endTime: maxDur
        });
        return Data_Lens_Setter.set(function ($228) {
            return prop(prop1($228));
        })(map(speedToY)(ticksY))(Data_Lens_Setter.set(function ($229) {
            return prop(prop2($229));
        })(map(speedToY)(ticksY))(Data_Lens_Setter.set(function ($230) {
            return prop(prop3($230));
        })(Data_Maybe.fromMaybe(1.0)(mapFlipped(maximum1(append(ticksY)(speedArrayFromHorizLine(cfg.horizontalLine))))(speedToY)))(Data_Lens_Setter.set(function ($231) {
            return prop(prop4($231));
        })(new Data_Maybe.Just(function ($232) {
            return printY(yToSpeed($232));
        }))(Data_Lens_Setter.set(function ($233) {
            return prop5(prop1($233));
        })(map(durationToX)(linesX))(Data_Lens_Setter.set(function ($234) {
            return prop5(prop4($234));
        })(new Data_Maybe.Just(function ($235) {
            return printX(xToDuration($235));
        }))(Data_Lens_Setter.set(function ($236) {
            return prop5(prop6($236));
        })(pixelsPerX)(Data_Lens_Setter.set(function ($237) {
            return prop5(prop2($237));
        })(map(durationToX)(ticksX))(Data_Lens_Setter.set(function ($238) {
            return prop5(prop7($238));
        })(durationToX(mempty))((function () {
            if (v.embedOpts.chart.showStreams) {
                return Data_Lens_Setter.set(function ($239) {
                    return prop8(prop9($239));
                })(mapFlipped1(perStreamPoints)(map(function (v1) {
                    return new Data_Tuple.Tuple(durationToX(v1.duration), speedToY(v1.speed));
                })));
            };
            return identity;
        })()(Data_Lens_Setter.set(function ($240) {
            return prop8(prop10($240));
        })(map(function (v1) {
            return new Data_Tuple.Tuple(durationToX(v1.duration), speedToY(v1.speed));
        })(points))(cfg)))))))))));
    };
};
var addBaseConfig = function (v) {
    return function (cfg) {
        return Data_Lens_Setter.set(prop11)([  ])((function () {
            if (v.appMode instanceof Visonum_Cross_Components_App_Types_AppState.ExpertMode) {
                return function (cfg2) {
                    return Data_Lens_Setter.set(function ($241) {
                        return prop(prop12($241));
                    })(true)(Data_Lens_Setter.set(function ($242) {
                        return prop5(prop12($242));
                    })(true)(cfg2));
                };
            };
            if (v.appMode instanceof Visonum_Cross_Components_App_Types_AppState.NormalMode) {
                return identity;
            };
            throw new Error("Failed pattern match at Visonum.Cross.Views.Chart.Configs (line 145, column 5 - line 149, column 29): " + [ v.appMode.constructor.name ]);
        })()(cfg));
    };
};
var downloadConfig = function (v) {
    return Data_Lens_Setter.set(function ($243) {
        return prop13(prop14($243));
    })(Visonum_Cross_Theme.getMeasurementColor(Fusion_Data_Measurement.Download.value)(v.theme.colors))(addLoadConfig({
        loadResult: v.loadResult,
        embedOpts: v.embedOpts
    })(addBaseConfig({
        appMode: v.appMode
    })(defaultChartProps(v.embedOpts))));
};
var pingConfig = function (v) {
    var yToDuration = function (v1) {
        return Fusion_Data_Duration.fromMs(v1);
    };
    var xToDuration = function (v1) {
        return Fusion_Data_Duration.fromMs(v1);
    };
    var printY = function (d) {
        return Data_Number_Format.toStringWith(Data_Number_Format.fixed(0))(unwrap(durTo3(d)));
    };
    var printX = function (d) {
        return Data_Number_Format.toStringWith(Data_Number_Format.fixed(0))(unwrap(durTo2(d)));
    };
    var durationToY = function (dur) {
        return (function (v1) {
            return v1;
        })(fromDuration(dur));
    };
    var durationToX = function (dur) {
        return (function (v1) {
            return v1;
        })(fromDuration(dur));
    };
    var dataPointsToDurationPing = function (points$prime) {
        var v1 = Data_Array.head(points$prime);
        if (v1 instanceof Data_Maybe.Just) {
            return map(function (v2) {
                return {
                    duration: Fusion_Data_Timestamp.diff(v2.timestamp)(v1.value0.timestamp),
                    pingTime: v2.pingTime
                };
            })(points$prime);
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return [  ];
        };
        throw new Error("Failed pattern match at Visonum.Cross.Views.Chart.Configs (line 346, column 40 - line 355, column 20): " + [ v1.constructor.name ]);
    };
    var points = dataPointsToDurationPing(v.pingResult.intermediates);
    var maxDurX = Data_Maybe.fromMaybe(mempty)(map1(function (v1) {
        return v1.duration;
    })(Data_Array.last(points)));
    var linesX = getTicksX({
        startTime: mempty,
        endTime: max(Fusion_Data_Duration.fromMs(100000.0))(maxDurX)
    });
    var ticksX = getTicksX({
        startTime: mempty,
        endTime: maxDurX
    });
    var maxDurY = Visonum_Cross_Util.getVisiblePingMax(map(function (v1) {
        return v1.pingTime;
    })(points));
    var ticksY = mapFlipped1(mapFlipped1(getRoundTicks({
        max: unwrap(durTo3(maxDurY))
    }))(Data_Time_Duration.Milliseconds))(convertDuration2);
    return Data_Lens_Setter.set(function ($244) {
        return prop13(prop14($244));
    })(Visonum_Cross_Theme.getMeasurementColor(Fusion_Data_Measurement.Ping.value)(v.theme.colors))(Data_Lens_Setter.set(function ($245) {
        return prop(prop1($245));
    })(map(durationToY)(ticksY))(Data_Lens_Setter.set(function ($246) {
        return prop(prop2($246));
    })(map(durationToY)(ticksY))(Data_Lens_Setter.set(function ($247) {
        return prop(prop3($247));
    })(Data_Maybe.fromMaybe(1.0)(mapFlipped(maximum2(ticksY))(durationToY)))(Data_Lens_Setter.set(function ($248) {
        return prop(prop4($248));
    })(new Data_Maybe.Just(function ($249) {
        return printY(yToDuration($249));
    }))(Data_Lens_Setter.set(function ($250) {
        return prop5(prop1($250));
    })(map(durationToX)(linesX))(Data_Lens_Setter.set(function ($251) {
        return prop5(prop4($251));
    })(new Data_Maybe.Just(function ($252) {
        return printX(xToDuration($252));
    }))(Data_Lens_Setter.set(function ($253) {
        return prop5(prop6($253));
    })(pixelsPerX)(Data_Lens_Setter.set(function ($254) {
        return prop5(prop2($254));
    })(map(durationToX)(ticksX))(Data_Lens_Setter.set(function ($255) {
        return prop5(prop7($255));
    })(durationToX(mempty))((function () {
        if (v.embedOpts.chart.showStreams) {
            return Data_Lens_Setter.set(function ($256) {
                return prop8(prop9($256));
            })([  ]);
        };
        return identity;
    })()(Data_Lens_Setter.set(function ($257) {
        return prop8(prop10($257));
    })(map(function (v1) {
        return new Data_Tuple.Tuple(durationToX(v1.duration), durationToY(v1.pingTime));
    })(points))(addBaseConfig({
        appMode: v.appMode
    })(defaultChartProps(v.embedOpts))))))))))))));
};
var uploadConfig = function (v) {
    return Data_Lens_Setter.set(function ($258) {
        return prop13(prop14($258));
    })(Visonum_Cross_Theme.getMeasurementColor(Fusion_Data_Measurement.Upload.value)(v.theme.colors))(addLoadConfig({
        loadResult: v.loadResult,
        embedOpts: v.embedOpts
    })(addBaseConfig({
        appMode: v.appMode
    })(defaultChartProps(v.embedOpts))));
};
var velocityDownloadConfig = function (v) {
    return Data_Lens_Setter.set(function ($259) {
        return prop13(prop15($259));
    })(new Data_Maybe.Just("Download Mbit/s"))(Data_Lens_Setter.set(function ($260) {
        return prop13(prop16($260));
    })(false)(Data_Lens_Setter.set(function ($261) {
        return prop13(prop17($261));
    })(true)(Data_Lens_Setter.set(function ($262) {
        return prop13(prop14($262));
    })(Visonum_Cross_Theme.getMeasurementColor(Fusion_Data_Measurement.Download.value)(v.theme.colors))(addLoadConfig({
        loadResult: v.loadResult,
        embedOpts: v.embedOpts
    })(addBaseConfig({
        appMode: v.appMode
    })(Data_Lens_Setter.set(prop18)(v.bookedSpeedMax)(defaultChartProps(v.embedOpts))))))));
};
export {
    downloadConfig,
    velocityDownloadConfig,
    getRoundTicks,
    pingConfig,
    uploadConfig
};
//# sourceMappingURL=index.js.map
